import { FETCH_COMMENTS_SUCCESS, FETCH_NEXT_COMMENTS_SUCCESS, FETCH_NEXT_REPLIES_SUCCESS, REFETCH_COMMENTS_DATA_SUCCESS, FETCH_PREV_COMMENTS_SUCCESS, FETCH_PREV_REPLIES_SUCCESS, VIEW_REPLY_TARGET_SUCCESS, FETCH_DEEP_LINK_SUCCESS, BULK_FETCH_COMMENTS_SUCCESS, } from '../comments/paging/comments-paging-actions';
import { PERMISSION_CHECK_START, PERMISSION_CHECK_END } from './members-actions';
import { keyBy, map } from 'lodash';
import { FETCH_LIVE_COMMENTS_SUCCESS } from '../comments/live-updates/live-updates-actions';
import { SET_BASIC_PARAMS, UPDATE_INSTANCE } from '../base-params/base-params-actions';
import { FOLLOW_MEMBER_FAILURE, FOLLOW_MEMBER_REQUEST, FOLLOW_MEMBER_SUCCESS, UNFOLLOW_MEMBER_FAILURE, UNFOLLOW_MEMBER_REQUEST, UNFOLLOW_MEMBER_SUCCESS, } from '../member-follow/member-follow-actions';
export function membersReducer(state = {
    currentOwner: { type: 'UNKNOWN' },
    membersCache: {},
    memberCheckPending: false,
    followedMembers: [],
}, action) {
    switch (action.type) {
        case UPDATE_INSTANCE:
        case SET_BASIC_PARAMS: {
            const { aid: visitorId } = action.payload.instanceValues;
            if (!visitorId || state.currentOwner.type === 'MEMBER') {
                return state;
            }
            else {
                return {
                    ...state,
                    currentOwner: { type: 'ANONYMOUS', identityId: visitorId },
                };
            }
        }
        case FETCH_DEEP_LINK_SUCCESS:
        case FETCH_COMMENTS_SUCCESS:
        case BULK_FETCH_COMMENTS_SUCCESS: {
            const { currentMember: initialCurrentMember, members, memberBadges = {}, memberRoles = {}, followedMemberIds = [], } = action.payload.response;
            const currentOwner = initialCurrentMember
                ? {
                    type: 'MEMBER',
                    member: {
                        ...initialCurrentMember,
                        memberBadges: memberBadges[initialCurrentMember.id] ?? [],
                        memberRoles: memberRoles[initialCurrentMember.id] ?? [],
                    },
                }
                : state.currentOwner;
            return {
                followedMembers: followedMemberIds.map((id) => ({ id, status: 'FOLLOWED' })),
                memberCheckPending: false,
                currentOwner,
                membersCache: {
                    ...state.membersCache,
                    ...keyBy(map(members, (m) => ({
                        ...m,
                        memberBadges: memberBadges[m.id] ?? [],
                        memberRoles: memberRoles[m.id] ?? [],
                    })), (m) => m.id),
                    ...(currentOwner.type === 'MEMBER'
                        ? { [currentOwner.member.id]: currentOwner.member }
                        : {}),
                },
            };
        }
        case FETCH_LIVE_COMMENTS_SUCCESS:
        case VIEW_REPLY_TARGET_SUCCESS: {
            const { members, memberBadges = {}, memberRoles = {} } = action.payload;
            return {
                ...state,
                membersCache: {
                    ...state.membersCache,
                    ...keyBy(map(members, (m) => ({
                        ...m,
                        memberBadges: memberBadges[m.id] ?? [],
                        memberRoles: memberRoles[m.id] ?? [],
                    })), (m) => m.id),
                },
            };
        }
        case FETCH_NEXT_COMMENTS_SUCCESS:
        case FETCH_PREV_COMMENTS_SUCCESS:
        case FETCH_NEXT_REPLIES_SUCCESS:
        case FETCH_PREV_REPLIES_SUCCESS: {
            const { members, memberBadges = {}, memberRoles = {} } = action.payload.response;
            return {
                ...state,
                membersCache: {
                    ...keyBy(map(members, (m) => ({
                        ...m,
                        memberBadges: memberBadges[m.id] ?? [],
                        memberRoles: memberRoles[m.id] ?? [],
                    })), (m) => m.id),
                    ...state.membersCache,
                },
            };
        }
        case REFETCH_COMMENTS_DATA_SUCCESS: {
            const { currentMember, memberBadges = {}, memberRoles = {} } = action.payload.response;
            if (!currentMember) {
                return {
                    ...state,
                    currentOwner: state.currentOwner,
                };
            }
            const currentOwner = {
                type: 'MEMBER',
                member: {
                    ...currentMember,
                    memberBadges: memberBadges[currentMember.id] ?? [],
                    memberRoles: memberRoles[currentMember.id] ?? [],
                },
            };
            return {
                ...state,
                currentOwner,
                membersCache: {
                    ...state.membersCache,
                    [currentOwner.member.id]: currentOwner.member,
                },
            };
        }
        case PERMISSION_CHECK_START: {
            return {
                ...state,
                memberCheckPending: true,
            };
        }
        case PERMISSION_CHECK_END: {
            return {
                ...state,
                memberCheckPending: false,
            };
        }
        case FOLLOW_MEMBER_REQUEST:
            return {
                ...state,
                followedMembers: [
                    ...state.followedMembers,
                    { id: action.payload.memberId, status: 'PENDING_FOLLOW' },
                ],
            };
        case FOLLOW_MEMBER_SUCCESS: {
            return {
                ...state,
                followedMembers: state.followedMembers.map((member) => {
                    if (member.id === action.payload.memberId) {
                        return { ...member, status: 'FOLLOWED' };
                    }
                    else {
                        return member;
                    }
                }),
            };
        }
        case FOLLOW_MEMBER_FAILURE: {
            return {
                ...state,
                followedMembers: state.followedMembers.filter((member) => member.id !== action.payload.memberId),
            };
        }
        case UNFOLLOW_MEMBER_REQUEST: {
            return {
                ...state,
                followedMembers: state.followedMembers.map((member) => {
                    if (member.id === action.payload.memberId) {
                        return { ...member, status: 'PENDING_UNFOLLOW' };
                    }
                    else {
                        return member;
                    }
                }),
            };
        }
        case UNFOLLOW_MEMBER_SUCCESS: {
            return {
                ...state,
                followedMembers: state.followedMembers.filter((member) => member.id !== action.payload.memberId),
            };
        }
        case UNFOLLOW_MEMBER_FAILURE: {
            return {
                ...state,
                followedMembers: state.followedMembers.map((member) => {
                    if (member.id === action.payload.memberId) {
                        return { ...member, status: 'FOLLOWED' };
                    }
                    else {
                        return member;
                    }
                }),
            };
        }
        default:
            return state;
    }
}
//# sourceMappingURL=members-reducer.js.map